import { ApplicationState } from "./../index";
import { PrepareSelectedAddons, IAddOn, PrepareAddonTexts } from "../AddOn";
import { PreparePriceList, GetUpdatedFooterPrices, FooterState } from "../Footer";
import { Coverage, GetCalculatedPrice } from "../Insurance";
import { RemoveDuplicates, DeepClone } from "../../helperFunctions";
import { BrandsEnum } from "../../enums";
import { setServerError } from "../error";
import { SERVER_ERROR_MESSAGE, API_HOST_ERROR_MESSAGE } from "../../constants/errorMessages";
import { toErrorPayload } from "../../helpers/errorPayload";

const method = "POST";
const headers = { "Content-Type": "application/json" };

const Calculate = async (state: ApplicationState, dispatch?: Function): Promise<ApplicationState> => {
  if (!state.inputs.apiHost) {
    if (dispatch) dispatch(setServerError(API_HOST_ERROR_MESSAGE, SERVER_ERROR_MESSAGE));
    throw toErrorPayload({ message: API_HOST_ERROR_MESSAGE, header: SERVER_ERROR_MESSAGE });
  }

  const brand = state.inputs?.partner ?? BrandsEnum.Polestar;
  const url = `${state.inputs.apiHost}/api2/${brand}/newwebshop/Calculate`;

  // prepare params;
  const d: number = +(state.distance?.selected || "0");
  const cid = state.insurance?.coverage?.selectedCode || "";

  const selectedAddonInternalCodes: string[] = state?.addon?.selectedAddOnInternalCodes ?? [];

  // todo: replace/improve;
  let data: any = {
    WebshopMode: state.inputs.webshopMode,
    CarRegistrationNumber: state.inputs.crn,
    SocialSecurityNumber: state.inputs.ssn,
    DeductibleCode: state.insurance?.coverage?.SelectedDeductible,
    GlassDeductibleCode: state.insurance?.coverage?.SelectedGlassDeductible,
    MileageCode: d,
    PaymentMethodCode: state.payment?.selectedPaymentTypeCode,
    BankCode: state.payment?.selectedBankCode,
    SelectedAddons: selectedAddonInternalCodes,
    CampaignId: state.profile?.campaignId ?? state.inputs.campaignId,
    Brand: brand,
    CoverageInternalCode: cid,
    QuoteNumber: state.inputs.quoteNumber,
    ProductId: null,
    DisableBuying: state.inputs.disableBuying,
    DealerPrice: false,
    CalculationMethod: state.inputs?.calculationMethod,
    CarCode: state.inputs.car?.code ?? "",
  };

  if (brand === BrandsEnum.Polestar) {
  } else {
    data = {
      ...data,
      IsDriverUnder25: state.youngDriver?.selected,
      CarHadAccidents: state.damageFreeYear?.selected,
    };
  }

  const response = await fetch(`${url}`, {
    method,
    mode: "cors",
    headers,
    body: JSON.stringify(data),
  });

  const json = await response.json();

  if (response.status !== 200) {
    //uppercase Message is for compatibility with old API responses
    const message = (json && json.Message) ?? SERVER_ERROR_MESSAGE;
    if (dispatch) dispatch(setServerError(message, SERVER_ERROR_MESSAGE));
    throw toErrorPayload({ message, header: SERVER_ERROR_MESSAGE });
  }

  // update coverage prices
  const coverages = DeepClone(state?.insurance?.coverage?.Coverages);
  coverages?.forEach(coverage => {
    const newCoveragePrice = json.CoveragePricings.find((x: any) => x.InternalCode === coverage.InternalCode);
    if (newCoveragePrice) {
      coverage.PrimaryPrice = newCoveragePrice.PrimaryPrice;
      coverage.SecondaryPrice = newCoveragePrice.SecondaryPrice;
      coverage.CoverageAddons?.forEach(addon => {
        const newAddonPrice = newCoveragePrice.AddonPricings.find((x: any) => x.InternalCode === addon.InternalCode);
        if (newAddonPrice) {
          addon.MonthlyPrice = newAddonPrice.Price.Amount;
        }
      });
    }
  });

  const currentCoverage = coverages?.find(x => x.InternalCode === cid);

  // update addon prices
  let addOns = DeepClone(state?.addon?.addOns);
  let updatedAddonPrices = json.CoveragePricings.flatMap((x: any) => x.AddonPricings).filter((x: any) => x != null) as {
    InternalCode: string;
    Price: {
      Amount: string;
    };
  }[];
  updatedAddonPrices = RemoveDuplicates(updatedAddonPrices);
  addOns?.forEach(addon => {
    const newPrice = updatedAddonPrices.find(x => x.InternalCode === addon.InternalCode);
    if (newPrice) {
      addon.MonthlyPrice = newPrice.Price.Amount;
    }
  });

  addOns = PrepareAddonTexts(addOns as IAddOn[]);

  addOns = PrepareSelectedAddons(addOns as IAddOn[], selectedAddonInternalCodes);

  // populate footer prices
  const footerPrices = GetUpdatedFooterPrices(state.footer as FooterState, currentCoverage as Coverage, selectedAddonInternalCodes);
  coverages?.forEach(x => {
    const tmp = PreparePriceList(x, selectedAddonInternalCodes);
    x.CalculatedPrice = tmp[0].price;

    // calculate secondary prices
    x.CalculatedPriceSecondary = GetCalculatedPrice(x.SecondaryPrice, x, selectedAddonInternalCodes);
  });

  return {
    addon: {
      ...state.addon,
      selectedAddOnInternalCodes: selectedAddonInternalCodes,
      addOns: addOns,
    },
    footer: {
      ...footerPrices,
      totalPriceTooltip: state.footer?.totalPriceTooltip,
      purchaseButton: state.footer?.purchaseButton,
      expanded: true,
    },
    insurance: {
      ...state.insurance,
      coverage: {
        ...state.insurance?.coverage,
        Coverages: coverages,
      },
    },
  } as ApplicationState;
};

export default Calculate;
